import React,{useState,useEffect} from 'react';
import { Swiper, SwiperSlide} from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import ImageTile from './ui-elements/ImageTile';
import MediaQuery from 'react-responsive';

import surahDetails from '../../data/structure/structure.json';

const PopularSurahSlide=({alimPlaylist,parentCompType})=>{
    const [zamzamPlaylist,setZamzamPlaylist]=useState(alimPlaylist);
    const [popularSurahsList,setPopularSurahsList]=useState([])

    const extractSurahNumber=(text)=>{
        const match = text.match(/Surah\s+(\d+):/);
        return match ? parseInt(match[1], 10) : null;
    }

    const generateRandomSurahs = (availableSurahNums) => {
        const surahNumArr = [];

        // Ensure we pick 7 unique numbers from availableSurahNums
        while (surahNumArr.length < 7 && availableSurahNums.length > 0) {
            const randomIndex = Math.floor(Math.random() * availableSurahNums.length);
            const randomNum = availableSurahNums[randomIndex];

            // Ensure the number is not already in the array
            if (!surahNumArr.includes(randomNum)) {
                surahNumArr.push(randomNum);
            }
        }

        return surahNumArr;
    };

    useEffect(()=>{
        // Initialize an array to store the results
        let matchedSurahs = [];

        let availableSurahNums = [];

        // Loop through zamzamPlaylist.items to extract surah numbers
        zamzamPlaylist.items.forEach(surah => {
            const tempSurahTitle = surah.snippet.title;
            const surahNum = extractSurahNumber(tempSurahTitle);
    
            // Add the surahNum to availableSurahNums array if it's not already present
            if (!availableSurahNums.includes(surahNum)) {
                availableSurahNums.push(surahNum);
            }
        });

        const popularSurahNumArr=parentCompType==="media-player-overlay"?generateRandomSurahs(availableSurahNums):[1, 99, 108, 110, 112, 113, 114];
        

        zamzamPlaylist.items.forEach(surah => {
            const tempSurahTitle = surah.snippet.title;
            const surahNum = extractSurahNumber(tempSurahTitle);
            
            // Check if the surah number is in the popularSurahNumArr
            if (popularSurahNumArr.includes(surahNum)) {
                // Create an object to store the videoId, thumbnail, and surahNum
                const surahData = {
                    surahNum: surahNum,
                    videoId: surah.snippet.resourceId.videoId,
                    thumbnail: surah.snippet.thumbnails.high,
                };
                
                // Push the object to the matchedSurahs array
                matchedSurahs.push(surahData);
            }
        });

        // Initialize an array to collect the updated surahs
        let updatedSurahs = [];

        matchedSurahs.forEach((surah) => {
            surahDetails.forEach((surahItem) => {
                const snum = parseInt(surahItem.index, 10);

                // Check if the surah number matches
                if (surah.surahNum === snum) {
                    // Add the surah data to the updatedSurahs array
                    updatedSurahs.push({
                        ...surah,
                        sname: surahItem.title,
                        snameEng: surahItem.titleEn,
                        ayahCount: surahItem.count
                    });
                }
            });
        });

        // Now update the state with all the collected surahs at once
        setPopularSurahsList(updatedSurahs);
    },[zamzamPlaylist]);

    useEffect(()=>{},[popularSurahsList]);

    return(
        <>
            {
                popularSurahsList.length>0?
                    <>
                        {/* Slide for mobile */}
                        <MediaQuery query="(max-width: 768px)">
                            <div>
                                <Swiper
                                    modules={[Autoplay]}
                                    spaceBetween={16}
                                    slidesPerView={1}
                                    loop={true}
                                    autoplay={{
                                        delay: 5000,
                                        disableOnInteraction: true,
                                    }}
                                >
                                    {
                                        popularSurahsList.map((surah,itemIndex)=>{
                                            return(
                                                <SwiperSlide key={itemIndex}>
                                                    <ImageTile surah={surah} parentCompType={parentCompType}/>
                                                </SwiperSlide>
                                            )
                                        })
                                    }
                                </Swiper>
                            </div>
                        </MediaQuery>

                        {/* Slide for tablet */}
                        <MediaQuery query="(min-width: 769px) and (max-width: 1023px)">
                            <div>
                                <Swiper
                                    modules={[Autoplay]}
                                    spaceBetween={16}
                                    slidesPerView={2}
                                    loop={true}
                                    autoplay={{
                                        delay: 5000,
                                        disableOnInteraction: true,
                                    }}
                                >
                                    {
                                        popularSurahsList.map((surah,itemIndex)=>{
                                            return(
                                                <SwiperSlide key={itemIndex}>
                                                    <ImageTile surah={surah}/>
                                                </SwiperSlide>
                                            )
                                        })
                                    }
                                </Swiper>
                            </div>
                            
                        </MediaQuery>

                        {/* Slider for desktop */}
                        <MediaQuery query="(min-width: 1024px)">
                            <div>
                                <Swiper
                                modules={[Autoplay]}
                                spaceBetween={16}
                                slidesPerView={3}
                                loop={true}
                                autoplay={{
                                    delay: 5000,
                                    disableOnInteraction: true,
                                }}
                                >
                                    {
                                        popularSurahsList.map((surah,itemIndex)=>{
                                            return(
                                                <SwiperSlide key={itemIndex}>
                                                    <ImageTile surah={surah}/>
                                                </SwiperSlide>
                                            )
                                        })
                                    }
                                </Swiper>
                            </div>
                        </MediaQuery>
                    </>
                : 
                    null
            }
        </>
    )
}

export default PopularSurahSlide;